var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t.cls-spicy-1 {\n\t\t\t\tfill: #d50000;\n\t\t\t}\n\n\t\t\t.cls-spicy-2 {\n\t\t\t\tfill: #00c853;\n\t\t\t}\n\n\t\t\t.cls-spicy-3 {\n\t\t\t\tfill: #795548;\n\t\t\t}\n\t\t"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 3",
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-spicy-1",
    d: "M22.25,10.82a3.52,3.52,0,0,1-1.56,1,.5.5,0,0,1-.47-.13,2.56,2.56,0,0,1-.7-1.48,3.66,3.66,0,0,0-2.37.72.49.49,0,0,1-.41,0,16.56,16.56,0,0,0-1.63,4.89C14,21.78,13.42,24.49,6.67,27a.48.48,0,0,0-.32.43.49.49,0,0,0,.25.47,8.94,8.94,0,0,0,4.47,1.19c3.92,0,7.9-2.55,10.46-7.08a22,22,0,0,0,3.1-9.44A6.19,6.19,0,0,0,22.25,10.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-spicy-2",
    d: "M23.22,8.54a4.48,4.48,0,0,1-.39.61l-.08.09-.14.09a1.09,1.09,0,0,1-.62.21.87.87,0,0,1-.25,0,1,1,0,0,1-.68-.7s0,0,0,0a.51.51,0,0,1,.07-.43A.91.91,0,0,0,21.26,8c-1-.28-3.22-.55-4.81,2.21a.49.49,0,0,0,.09.61.42.42,0,0,0,.2.1.49.49,0,0,0,.41,0,3.66,3.66,0,0,1,2.37-.72,2.56,2.56,0,0,0,.7,1.48.5.5,0,0,0,.47.13,3.52,3.52,0,0,0,1.56-1,6.19,6.19,0,0,1,2.38,1.79.91.91,0,0,1,.13.16.53.53,0,0,0,.39.18.41.41,0,0,0,.16,0,.49.49,0,0,0,.34-.46A3.77,3.77,0,0,0,23.22,8.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-spicy-3",
    d: "M24.06,3.49a.51.51,0,0,0-.55-.41l-2.1.27a.51.51,0,0,0-.35.22A.49.49,0,0,0,21,4,10.55,10.55,0,0,1,21.26,8a.91.91,0,0,1-.14.33.51.51,0,0,0-.07.43s0,0,0,0a1,1,0,0,0,.68.7.87.87,0,0,0,.25,0,1.09,1.09,0,0,0,.62-.21l.14-.09.08-.09a4.48,4.48,0,0,0,.39-.61A8.11,8.11,0,0,0,24.06,3.49Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpicy);
export default __webpack_public_path__ + "static/media/spicy.5ab242cc45c0d0e4e72d6ee0bbb1cf9b.svg";
export { ForwardRef as ReactComponent };